module.exports = __webpack_public_path__ + "static/media/spacedrep.dd293bae.png";